import {Component, Injector, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {AcompanhamentoDeprService} from '../acompanhamento-depr.service';
import {
  AcompanhamentoDocumentoDepr,
  PeriodoAcompanhamentoDocumentoDepr,
  TipoAcompanhamentoDocumentoDepr
} from '../../../../model/acompanhamento-documento-depr.model';
import {Estado} from '../../../../model/estado.model';

import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_DEPR_CONSULTA } from 'src/app/constantes/permissao.constants';


@Component({
  selector: "app-acompanhamento-depr-cadastro",
  templateUrl: "./acompanhamento-depr-cadastro.component.html",
  styleUrls: ["./acompanhamento-depr-cadastro.component.scss"],
  standalone: false,
})
export class AcompanhamentoDeprCadastroComponent implements OnInit{

  perfilConsultaDEPR = false;
  clickEnviar = new Subject();
  disabledBtnEnviar: boolean = true;
  acompanhamentoDetalhe: boolean = false;
  ideAcompanhamentoDepr: number;
  acompanhamentoDepr: AcompanhamentoDocumentoDepr;

  @ViewChild('msgTemplateRejeitar')
  msgTemplateRejeitar: TemplateRef<any>;
  @ViewChild('msgTemplateValidar')
  msgTemplateValidar: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosRejeitar')
  botoesPersonalizadosRejeitar: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosValidar')
  botoesPersonalizadosValidar: TemplateRef<any>;

  constructor( protected injector: Injector,
               private route: ActivatedRoute,
               private service: AcompanhamentoDeprService,
               private bnModalService: BnModalMessageService,
               private messageService: MessageChannelService,
               private router: Router,
               private permissaoService: PermissaoService,
               ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.ideAcompanhamentoDepr = params['id'];
      if(this.ideAcompanhamentoDepr != null || this.ideAcompanhamentoDepr != undefined) {
        this.acompanhamentoDetalhe = true;
        if (this.acompanhamentoDetalhe){
          this.service.getAcompanhamentoDepr(this.ideAcompanhamentoDepr).subscribe(resp => {
            this.acompanhamentoDepr = resp;
          });
        }
      }
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.perfilConsultaDEPR = resp && resp[ROLE_DEPR_CONSULTA];
    });
  }

  enviar() {
    this.clickEnviar.next(true);
  }

  updateStatusDisabledBtnEnviar(event: any) {
    this.disabledBtnEnviar = event;
  }

  prepararValidar() {
    this.acompanhamentoDepr.motivoEstado = "";
    this.bnModalService.abrir(
      'Confirmação',
      'Inserir justificativa de validação do documento.',
      'lg',
      this.msgTemplateValidar,
      this.botoesPersonalizadosValidar
    );
  }

  validar() {
    this.service.validar(this.acompanhamentoDepr).subscribe(resp => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Documento avaliado pelo DEPR'
      });
      this.bnModalService.dismiss();
      this.router.navigate(["/acompanhamento-documento-depr"])
    });
  }

  prepararRejeitar() {
    this.acompanhamentoDepr.motivoEstado = "";
    this.bnModalService.abrir(
      'Confirmação',
      'Inserir justificativa de rejeição do documento.',
      'lg',
      this.msgTemplateRejeitar,
      this.botoesPersonalizadosRejeitar
    );
  }

  rejeitar() {
    this.service.rejeitar(this.acompanhamentoDepr).subscribe(resp => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Documento avaliado pelo DEPR'
      });
      this.bnModalService.dismiss();
      this.router.navigate(["/acompanhamento-documento-depr"]);
    });
  }

  podeAvaliar() {
    return this?.perfilConsultaDEPR && Number(this.acompanhamentoDepr?.estado?.id) === PeriodoAcompanhamentoDocumentoDepr.EM_VALIDACAO.valueOf();
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }
}
